import { render, staticRenderFns } from "./MarketMain.vue?vue&type=template&id=6ac89e4f&scoped=true"
import script from "./MarketMain.vue?vue&type=script&lang=js"
export * from "./MarketMain.vue?vue&type=script&lang=js"
import style0 from "./MarketMain.vue?vue&type=style&index=0&id=6ac89e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac89e4f",
  null
  
)

export default component.exports